// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2uXS_","header":"Messages_header__1nb4z"};